import { FormControl, FormGroup } from '@angular/forms';
import { EditPermissions } from '../../../../../../../shared/models';
import { required } from '../../../../../../../shared/utils';
import { getEditTypes } from '../../../delegatorUtils';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';

export interface DisplayMenuData {
  text: string,
  endSession: boolean
}

export interface LogicData {
  next: string;
}

export interface DisplayMenuForms {
  DisplayMenuForm: FormGroup,
  LogicForm: FormGroup
}

export class DisplayMenu {

  menu: any = {};
  step: any = {};

  constructor(formData: DisplayMenuData, logicData: LogicData) {
    this.menu = {
      'menuType': 'displayMenu',
    };
    this.setNodeData(formData);
  }

  static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): DisplayMenuForms {
    const { editMenuTextOnly, editFlows } = getEditTypes(editPermissions);
    const formData = this.getFromData(stepData);
    const logicData: LogicData = this.getLogicData(stepData);

    return {
      DisplayMenuForm: this.buildForm(formData, editFlows),
      LogicForm: this.buildLogicForm(logicData, formData, editFlows),
    };
  }

  private static getFromData(stepData: { [index: string]: any }): DisplayMenuData {
    const menu = stepData?.menu ? stepData?.menu : {};
    const menuParams = menu?.menuParams ? menu?.menuParams : {};

    return {
      text: menu.text ? menu.text : '',
      endSession: menuParams.endSession !== undefined ? menuParams.endSession : true,
    };
  }

  private static buildForm(formData: DisplayMenuData, editFlows: boolean): FormGroup {
    return new FormGroup({
      text: new FormControl({
        value: formData.text,
        disabled: !editFlows,
      }, required('Text')),
      endSession: new FormControl({
        value: formData.endSession ? formData.endSession : false,
        disabled: !editFlows,
      }),
    });
  }


  static getLogicData(stepData: { [index: string]: any }): LogicData {
    return {
      next: stepData?.next ? stepData.next : newStepValue,
    };
  }

  public static buildLogicForm(logicData: LogicData, formData: DisplayMenuData, editFlows: boolean): FormGroup {
    if (!formData.endSession) {
      return new FormGroup({
        next: new FormControl({
          value: logicData.next,
          disabled: !editFlows,
        }),
      });
    }

    return null;
  }

  nodeData(next?: string): {} {
    const returnValue = {
      menu: this.menu,
      'type': 'menu',
      metadata: {
        nodeVersion: '1.0.0',
      },
    };

    if (next) {
      returnValue['next'] = next;
    }

    return returnValue;
  }

  setNodeData(formData: DisplayMenuData) {
    const { text, endSession } = formData;

    this.menu = {
      ...this.menu,
      text,
      menuParams: { endSession },
    };
  }
}

/*
  json: {
    menu: {
      menuType: 'displayMenu',
      text: '',
    menuParams: {
      endSession: true,
    }
*/
